import { create } from 'zustand';
import { CAROUSEL_TYPES } from '../constants/carouselTypes';

export const useAppStore = create((set) => ({
  menuActiveKey: null,
  setMenuActiveKey: (param) => set({menuActiveKey: param}),

  fullScreen: false,
  toggleFullScreen: () =>
    set((state) => ({ fullScreen: !state.fullScreen })),

  hideHeader: false,
  setHideHeader: (hide) => set({ hideHeader: hide }),

  carousel: {
    // tipo de carousel: 'demo' o 'speakers'
    type: null,
    isOpen: false,
    currentIndex: 0,
    openCarousel: (index, carouselType = CAROUSEL_TYPES.DEMO) =>
      set((state) => ({
        carousel: { ...state.carousel, isOpen: true, currentIndex: index, type: carouselType },
      })),
    closeCarousel: () =>
      set((state) => ({
        carousel: { ...state.carousel, isOpen: false, type: null },
      })),
  },

  // Estado del contenido JSON
  content: null,
  isLoading: true,
  error: null,

  menuItems: [],

  // Método para cargar contenido desde un archivo JSON
  loadContent: async () => {
    try {
      const response = await fetch("/data.json"); // Reemplaza con el path correcto
      if (!response.ok) throw new Error("Error al cargar el JSON");
      const data = await response.json();
      set({ content: data, menuItems: data.menu, isLoading: false, error: null });
    } catch (error) {
      set({ error: error.message, isLoading: false });
    }
  },

  mapOptions: {},
  setMapOptions: (params) => set({mapOptions: params}),
  resetMapOptions: () => set({mapOptions: {id: null}}),

  sidebarCollapsed: false,
  setSidebarCollapsed: (collapsed) => set({ sidebarCollapsed: collapsed }),

  searchIsOpen: false,
  setSearchIsOpen: (open) => set({ searchIsOpen: open }),
  searchIsExiting: false,
  setSearchIsExiting: (b) => set({ searchIsExiting: b }),

  cardTouchPos: {},
  setCardTouchPos: (point) => set({ cardTouchPos: point }),
}));
